import React from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { Props } from "./types";
import styles from "./styles.scss";
import { toFixed } from "@common/projectSection/utils";

function ActivityMonitoringSection({ project }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.sectionContainer}>
      <div className={styles.sectionRow}>
        <div className={styles.sectionLabel}>
          {t("projectSection.columnNames.activityMonitoring_done")}
        </div>
        <div className={styles.sectionValue}>
          <p className={classNames(styles.text, styles.positive)}>
            {toFixed(project.proportionOfAccomplishedWork)}%
          </p>
        </div>
      </div>
      <div className={styles.sectionRow}>
        <div className={styles.sectionLabel}>
          {t("projectSection.columnNames.activityMonitoring_delayed")}
        </div>
        <div className={styles.sectionValue}>
          <p className={classNames(styles.text, styles.warning)}>
            {toFixed(project.proportionOfDelayedWork)}%
          </p>
        </div>
      </div>
      <div className={styles.sectionRow}>
        <div className={styles.sectionLabel}>
          {t("projectSection.columnNames.activityMonitoring_opened")}
        </div>
        <div className={styles.sectionValue}>
          <p className={styles.text}>
            {toFixed(project.proportionOfOpenedWork)}%
          </p>
        </div>
      </div>
    </div>
  );
}

export { ActivityMonitoringSection };
